import { View } from "@react-pdf/renderer"
import Text from "./Text"
import { useTranslation } from "react-i18next"

export type NumberAnswerProps = {
  placeholder: string
  value: number
}

const NumberAnswer = ({ placeholder, value }: NumberAnswerProps) => {
  const { t } = useTranslation()

  return (
    <View style={{ marginBottom: 16 }} wrap={false}>
      <Text style={{ fontWeight: "bold", fontSize: 12, marginLeft: 40 }}>
        {t("general.answer")}:{"\u00A0"}
        {`${value} ${placeholder}`}
      </Text>
    </View>
  )
}

export default NumberAnswer
